import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";
import loadImage from "../../utils/preaload";

class PipelineMenuBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: utils.getParams('tabActive')
    };
    this.pageId = utils.getPageId();
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.onload = () => {
        const menuHeight = document.querySelector(".menu-item-wrap").clientHeight;
        document.querySelector('.App').style.paddingBottom = menuHeight + 15 + "px";
      }

      const { grains } = this.props.config.containerConfig;
      const preadload = [];
      grains && grains.length > 0 && grains.some((item, index) => {
        preadload.push(item.selectedImg);
        preadload.push(item.unselectedImg);
        if (item.menuHref && item.menuHref.replace(/\s/g, '') == this.pageId) {
          this.setState({
            selected: index
          }, () => {
            const tabChName = grains[this.state.selected] && grains[this.state.selected].menuName;
            window.sessionStorage.setItem('tabChName', tabChName);
          });
          return true;
        }
      });

      loadImage(preadload, (complete) => {
        if (complete) {
          console.log('加载完了'); 
        }
      })
    }
  }

  handleMenuSelect = (event, item, index) => {
    event.preventDefault();
    if (index === this.state.selected) {
      return;
    }
    this.setState({
      selected: index
    });

    if (item.menuHref) {
      item.menuHref = item.menuHref.replace(/\s/g, '');
      const isStage = window.location.href.indexOf('/stage/page') >= 0
      if (!isStage) {
        window.location.href =  `https://zt-public.shihuo.cn/page/${item.menuHref}/index.html?tabActive=${index}`;
      } else {
        window.location.href =  `https://zt-public.shihuo.cn/stage/page/${item.menuHref}/index.html?tabActive=${index}`;
      }
    }

    const newProps = JSON.parse(JSON.stringify(this.props));
    Object.assign(newProps, {
      tabChName: item.menuName
    });
    utils.uploadTrack(newProps, {
      sort: index
    });
  }

  render() {
    const { selected } = this.state;
    const { backgroundColor } = this.props.config.baseConfig;
    const { grains } = this.props.config.containerConfig;
    if (!grains || grains.length <= 0) {
      return null;
    }
    return (
      <div
        className="pipeline-menuBar"
        {...this.props['customAttributes']}
      >
        <div className={`menu-item-wrap menu-num-${grains.length}`} style={{ backgroundColor: backgroundColor }}>
          <ul>
            {
              grains.map((item, index) => {
                let menuClassNav = "";
                menuClassNav = selected == index ? 'menu-item-nav active' : 'menu-item-nav';
                return (
                  <li
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {
                      tabChName: item.menuName,
                      sort: index,
                    }))}
                    className={menuClassNav}
                    key={`menu-item-nav-${index}`}
                    onClick={(event) => this.handleMenuSelect(event, item, index)}
                  >
                    <img src={selected == index ? item.selectedImg : item.unselectedImg} />
                  </li>
                )
              })
            }
          </ul>
          {(utils.isIphoneX() || utils.isIphone14ProMax()) && <div className="safe-line"></div>}
        </div>
      </div>
    )
  }
}

PipelineMenuBar.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineMenuBar };
export default PipelineMenuBar;



// WEBPACK FOOTER //
// ./components/pipeline-menuBar/index.js